export default __webpack_public_path__ + "static/media/project.3a4152f6.svg";